





























































// vue
import { defineComponent, ref, Ref, computed } from '@vue/composition-api'

// componnents
import { PageHeader, ButtonExport, AccordionFilters } from '@/components'
import { Modal } from '@/components/general'
import { CuartaCategoriaTableList, CuartaCategoriaFormCreateEdit, FiltersCuartaCategoria as Filters } from '@/components/dailyControl'

// services
import { CuartaCategoriaService } from '@/services/dailyControl'

// models
import { Paginator } from '@/models'
import { CuartaCategoria, CuartaCategoriaForm, FiltersCuartaCategoria } from '@/models/dailyControl'

// utils
import { loading, alerts, getFullNameFormat } from '@/utils'

// constants
import { actionFormTypes } from '@/constants'

const cuartaCategoriaDefault: CuartaCategoriaForm = {
  employee_id: null,
  register_date: null,
  type: null,
  discount_date: null,
  amount: 0,
  observations: ''
}

export default defineComponent({
  name: 'CuartaCategoriaIndex',
  components: {
    PageHeader,
    CuartaCategoriaTableList,
    Modal,
    CuartaCategoriaFormCreateEdit,
    ButtonExport,
    AccordionFilters,
    Filters
  },
  setup () {
    const showModal = ref(false)
    const title = 'Control de Bonos de 4ta Categoría'
    const actionForm = ref(actionFormTypes)
    const idEdit: Ref<number|null> = ref(null)
    const titleModal = computed(() => {
      if (actionForm.value === 'update') {
        return 'Editar Control de Bonos de 4ta Categoría'
      }
      return 'Crear Control de Bonos de 4ta Categoría'
    })
    const items = [
      {
        text: 'Dashboard',
        to: { name: 'home' }
      },
      {
        text: 'Control de Bonos de 4ta Categoría',
        active: true
      }
    ]
    const pagination: Ref<Paginator> = ref({
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    })
    const filters: Ref<FiltersCuartaCategoria> = ref({
      registerDate: null,
      applyDate: null,
      employee: null
    })
    const cuartaCategoria: Ref<CuartaCategoriaForm> = ref(cuartaCategoriaDefault)
    const allCuartaCategoria: Ref<CuartaCategoria[]> = ref([])
    const getCuartaCategoriaWithPagination = async () => {
      loading('show')
      const res = await CuartaCategoriaService.getWithPagination(pagination.value.perPage, pagination.value.currentPage, filters.value)
      pagination.value = res.pagination
      allCuartaCategoria.value = res.objects
      loading('hide')
    }
    getCuartaCategoriaWithPagination()
    const addNew = () => {
      actionForm.value = 'save'
      showModal.value = true
      cuartaCategoria.value = {
        ...cuartaCategoriaDefault
      }
    }
    const saveSuccess = () => {
      showModal.value = false
      actionForm.value = 'save'
      cuartaCategoria.value = {
        ...cuartaCategoriaDefault
      }
      idEdit.value = null
      getCuartaCategoriaWithPagination()
    }
    const editItem = (item: CuartaCategoria) => {
      cuartaCategoria.value = {
        employee_id: item.employee_id,
        type: item.type,
        register_date: item.register_date,
        discount_date: item.discount_date,
        amount: item.amount,
        observations: item.observations
      }
      idEdit.value = Number(item.id)
      actionForm.value = 'update'
      showModal.value = true
    }

    const deleteItem = async (item: CuartaCategoria) => {
      const msg = `Seguro que desea eliminar el Adelanto del Empleado: ${item.employee.fullName}, con fecha de: ${item.register_date}`
      const confirm = await alerts.confirm(msg)
      if (confirm) {
        loading('show')
        await CuartaCategoriaService.delete(item.id)
        alerts.success()
        getCuartaCategoriaWithPagination()
      }
    }

    const changePage = (page: number) => {
        pagination.value.currentPage = page
        getCuartaCategoriaWithPagination()
    }

    const changePerPage = (perPage: number) => {
        pagination.value.perPage = perPage
        pagination.value.currentPage = 1
        getCuartaCategoriaWithPagination()
    }

    const headersExcel = [
      { text: 'Fecha de Registro', value: 'register_date' },
      { text: 'Fecha de Descuento', value: 'discount_date' },
      { text: 'Empleado', value: 'employee' },
      { text: 'Importe', value: 'amount' }
    ]

    const itemsExcel = computed(() => {
      return allCuartaCategoria.value.map(item => {
        return {
          ...item,
          employee: getFullNameFormat(item.employee)
        }
      })
    })

    const getAllitems = async () => {
      allCuartaCategoria.value = await CuartaCategoriaService.getAll(filters.value)
    }

    const getByFilters = () => {
      pagination.value.currentPage = 1
      getCuartaCategoriaWithPagination()
    }

    const clearFilters = () => {
      pagination.value.currentPage = 1
      filters.value = {
        registerDate: null,
        applyDate: null,
        employee: null
      }
      getCuartaCategoriaWithPagination()
    }

    return {
      items,
      title,
      addNew,
      showModal,
      titleModal,
      cuartaCategoria,
      saveSuccess,
      allCuartaCategoria,
      deleteItem,
      idEdit,
      editItem,
      actionForm,
      pagination,
      changePage,
      changePerPage,
      headersExcel,
      itemsExcel,
      getAllitems,
      filters,
      getByFilters,
      clearFilters
    }
  }
})
